module.exports = __webpack_public_path__ + "img/fl.7031de0e.jpg";